export default __webpack_public_path__ + "alberta-seriesorder.ffb736671bfb63207f39.svg";